import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import ScrollToTop from "./components/common/ScrollToTop";
import Home from "../src/pages/Home";
import About from "../src/pages/About";
import BiospecimensServices from "../src/pages/BiospecimensServices";
import BiospecimenCategory from "../src/pages/BiospecimenCategory";
import Biostorage from "../src/pages/Biostorage";
import CentralLabTesting from "../src/pages/CentralLabTesting";
import QualityAndCompliance from "../src/pages/QualityAndCompliance";
import Contact from "../src/pages/Contact";
import RFQForm from "../src/pages/Form";
import CustomizedServiceDetail from "../src/pages/CustomizedServiceDetail";

const AppRoutes = () => {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route
          path="/biospecimens-services"
          element={<BiospecimensServices />}
        />
        {/* <Route
          path="/biospecimens-category"
          element={<BiospecimenCategory />}
        /> */}
        <Route path="/biostorage" element={<Biostorage />} />
        <Route path="/lab-testing" element={<CentralLabTesting />} />
        <Route path="/quality-compliance" element={<QualityAndCompliance />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/rfq" element={<RFQForm />} />
        <Route
          path="/customized-services"
          element={<CustomizedServiceDetail />}
        />

        {/* Redirect any other path to Home */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
};

export default AppRoutes;
